import React from "react";
import { InputWrapper, Select as SelectUI, Label, RequiredLabel, SelectWrapper, ErrorMessage } from "./Inputs.styled";

var Select = function Select(_a) {
  var label = _a.label,
      isRequired = _a.isRequired,
      placeholder = _a.placeholder,
      options = _a.options,
      value = _a.value,
      errorMessage = _a.errorMessage,
      _onChange = _a.onChange;
  return React.createElement(InputWrapper, {
    hasError: !!errorMessage
  }, React.createElement(Label, {
    mb: 1
  }, label, isRequired && React.createElement(RequiredLabel, {
    as: "span"
  }, "(pole obowi\u0105zkowe)")), React.createElement(SelectWrapper, {
    htmlFor: "select"
  }, React.createElement(SelectUI, {
    id: "select",
    onChange: function onChange(_a) {
      var target = _a.target;
      return _onChange(target.value);
    },
    required: isRequired,
    placeholder: placeholder,
    value: value
  }, React.createElement("option", {
    value: ""
  }, placeholder), options.map(function (_a) {
    var label = _a.label,
        value = _a.value;
    return React.createElement("option", {
      value: value
    }, label);
  }))), !!errorMessage && React.createElement(ErrorMessage, null, errorMessage));
};

export default Select;